import useUpdateRecordDialog from 'hooks/useUpdateRecordDialog';
import { useUpdateTeamMutation } from 'store/slices/apiV1/properties';
import {
  createUpdateTeamFormConstants,
  createUpdateTeamValidationSchema,
} from 'views/properties/Teams/components/constants';
import { HookFormInput } from 'ui-component/HookFormComponents';
import { TeamLite } from 'types/properties';
import { HookFormTeamTypeAutocomplete } from 'ui-component/HookFormComponents/HookFormTeamTypeAutocomplete';
import useCustomTeamTypeName from 'hooks/useCustomTeamTypeName';

type UpdateTeamDialogProps = {
  dialogOpen: boolean;
  onClose: () => void;
  teamToUpdate: TeamLite;
};

const UpdateTeamDialog = ({
  dialogOpen,
  onClose,
  teamToUpdate,
}: UpdateTeamDialogProps) => {
  const { handleReplaceWithCustomTeamName } = useCustomTeamTypeName();

  const formDefaults = {
    [createUpdateTeamFormConstants.name.id]: teamToUpdate.name ?? '',
    [createUpdateTeamFormConstants.teamType.id]:
      teamToUpdate?.teamType?.id ?? '',
  };

  const { methods, control, errors, BaseUpdateRecordDialog, dialogProps } =
    useUpdateRecordDialog({
      formConstants: createUpdateTeamFormConstants,
      validationSchema: createUpdateTeamValidationSchema(
        handleReplaceWithCustomTeamName
      ),
      useUpdateMutation: useUpdateTeamMutation,
      newRecordDefaults: formDefaults,
      recordName: handleReplaceWithCustomTeamName('Team'),
      idProp: 'id',
      selectedRecord: teamToUpdate,
    });

  return (
    <BaseUpdateRecordDialog
      open={dialogOpen}
      onClose={onClose}
      dialogProps={dialogProps}
    >
      <HookFormInput
        name={createUpdateTeamFormConstants.name.id}
        label={handleReplaceWithCustomTeamName(
          createUpdateTeamFormConstants.name.label
        )}
        control={control}
        errors={errors}
      />
      <HookFormTeamTypeAutocomplete
        name={createUpdateTeamFormConstants.teamType.id}
        label={handleReplaceWithCustomTeamName(
          createUpdateTeamFormConstants.teamType.label
        )}
        control={control}
        errors={errors}
        defaultValue={formDefaults[createUpdateTeamFormConstants.teamType.id]}
        setValue={methods.setValue}
      />
    </BaseUpdateRecordDialog>
  );
};

export default UpdateTeamDialog;
